import { Spin, Typography } from "antd";
import { nb } from "date-fns/locale";
import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { BookingSeason } from "../interface";
import "./Calendar.css";

interface Props {
  bookingSeason: BookingSeason;
  setSelectedDay: (newDate: Date | undefined) => void;
  loading: boolean;
}

const Calendar: React.FC<Props> = ({ bookingSeason, setSelectedDay, loading }) => {
  const [selected, setSelected] = React.useState<Date>();

  const otDays: Date[] = [];
  const kdDays: Date[] = [];
  const otherUnavailableDates: Date[] = [...(bookingSeason.unavailable_dates_other || []).map(day => new Date(day))];
  const parterUnavailableDates: Date[] = [
    ...(bookingSeason.unavailable_dates_collaboration_partner || []).map(day => new Date(day)),
  ];
  const bookedDays: Date[] = [...(bookingSeason.booked_days || []).map(day => new Date(day))];

  const currentOtDay = new Date(bookingSeason.unavailable_date_ot_start);
  while (currentOtDay <= new Date(bookingSeason.unavailable_date_ot_end)) {
    otDays.push(new Date(currentOtDay)); // Disable KD days
    currentOtDay.setDate(currentOtDay.getDate() + 1);
  }

  const currentKdDay = new Date(bookingSeason.unavailable_date_kd_start);
  while (currentKdDay <= new Date(bookingSeason.unavailable_date_kd_end)) {
    kdDays.push(new Date(currentKdDay)); // Disable KD days
    currentKdDay.setDate(currentKdDay.getDate() + 1);
  }

  const disabled = otherUnavailableDates.concat(otDays, kdDays, parterUnavailableDates, bookedDays);

  const currentDate = new Date(bookingSeason.semester_start);
  while (currentDate < new Date(bookingSeason.semester_end)) {
    if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
      disabled.push(new Date(currentDate)); // Disable weekends
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  const footer = (
    <Typography style={{ paddingTop: "16px", paddingLeft: "16px", fontSize: "medium" }}>
      {selected
        ? `Du har valgt ${selected.toLocaleDateString("no-nb", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}.`
        : "Velg en dato for bedriftspresentasjon."}
    </Typography>
  );

  return (
    <div style={{ position: "relative" }}>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Spin />
        </div>
      )}
      <DayPicker
        locale={nb}
        mode="single"
        showWeekNumber
        selected={selected}
        onSelect={d => {
          if (!loading) {
            d?.setHours(12);
            setSelected(d);
            setSelectedDay(d);
          }
        }}
        footer={footer}
        fromDate={new Date(bookingSeason.semester_start)}
        toDate={new Date(bookingSeason.semester_end)}
        disabled={disabled || loading}
        modifiers={{ bookedDays, otDays, kdDays }}
        modifiersClassNames={{
          selected: "selectedDay",
          disabled: "disabledDay",
          bookedDays: "bookedDay",
          otDays: "otDay",
          kdDays: "kdDay",
        }}
        style={{ opacity: loading ? 0.5 : 1 }}
      />
    </div>
  );
};

export default Calendar;
